// Public release metadata only. The focused test binds this to the canonical
// config/proof-rule-reference-release.json; the server independently pins import.
export default {
  package_sha256: '9df23f6b001fc3288b01e8d3ee0352520f46df78cd6a635cc22d2d9e61c04fe1',
  reference_count: 2456,
} as const;
